<template>
    <div class="syccxhz" v-loading="loading">
        <div class="syccxhzHeader">
            <!--          <div></div>-->
            <div class="sycBottom">
                <p>Production and Sales of Truck (by Tonnage) in {{returnEnY(date[1])}} {{date[0]}}</p>
            </div>
            <div class="sycDan">
                <p>in unit</p>
            </div>
        </div>
        <div>
            <table border="1" style="width: 100%;padding: 5px" class="hisTable" id="tal">
                <thead>
                     <tr class="headerClass">
                        <td rowspan="3">Model</td>
                        <td colspan="6">Production</td>
                        <td colspan="6">Sales</td>
                        <td colspan="2" >Sales/Production,%</td>
                       
                    </tr>
                    <tr class="headerClass">
                        <td rowspan="2">{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{parseInt(date[0].substring(date[0].length - 2))-1}}</td>
                        <td colspan="3">Change %</td>
                        <td rowspan="2">{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{parseInt(date[0].substring(date[0].length - 2))-1}}</td>
                        <td colspan="3">Change %</td>
                    
                        <td rowspan="2">{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                        <td rowspan="2">Jan-{{returnEng(date[1])}} {{date[0].substring(date[0].length - 2)}}</td>
                    </tr>
                    <tr class="headerClass">
                        
                        <td>Prior Month</td>
                        <td>The same month of previous year</td>
                        <td>YTD</td>
                        <td>Prior Month</td>
                        <td>The same month of previous year</td>
                        <td>YTD</td>
                       
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in tableData" :key="index">



                        <td>{{item.zhibiao_english}}</td>
                        <td>{{item.scBywc}}</td>
                        <td>{{item.scBqzlj}}</td>
                        <td>{{item.scTqzlj}}</td>
                        <td>{{item.scBsyzz}}</td>
                        <td>{{item.scBtqzz}}</td>
                        <td>{{item.scBtqljzz}}</td>

                        <td>{{item.xsBywc}}</td>
                        <td>{{item.xsBqzlj}}</td>
                        <td>{{item.xsTqzlj}}</td>
                        <td>{{item.xsBsyzz}}</td>
                        <td>{{item.xsBtqzz}}</td>
                        <td>{{item.xsBtqljzz}}</td>

                         <td>{{item.bycxl}}</td>
                        <td>{{item.bqcxl}}</td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</template>
<script>
import { getZhcfdwcxqkb } from "@/api/data";
import { combineCell } from "@/utils/tableData.js";
export default {
    data() {
        return {
            tableData: [],
            date: null,
            loading:true
        };
    },
    created() {
        let date = this.$route.params.date;
        this.date = date.split("-");
        this.getZhcfdwcxqkb(date.split("-").join(""));
    },
    methods: {
        getZhcfdwcxqkb(date) {
            getZhcfdwcxqkb({ dataDate: date }).then((res) => {
                if (res.code == 200) {
                    this.tableData = combineCell(res.data);
                }
                this.loading = false
            });
        },
        returnEnY(m) {
            let str = "";
            switch (m) {
                case "01":
                    str = "January";
                    break;
                case "02":
                    str = "February";
                    break;
                case "03":
                    str = "March";
                    break;
                case "04":
                    str = "April";
                    break;
                case "05":
                    str = "May";
                    break;
                case "06":
                    str = "June";
                    break;
                case "07":
                    str = "July";
                    break;
                case "08":
                    str = "August";
                    break;
                case "09":
                    str = "September";
                    break;
                case "10":
                    str = "October";
                    break;
                case "11":
                    str = "November";
                    break;
                case "12":
                    str = "December";
                    break;
            }
            return str;
        },
        returnEng(m) {
            let str = "";
            switch (m) {
                case "01":
                    str = "Jan";
                    break;
                case "02":
                    str = "Feb";
                    break;
                case "03":
                    str = "Mar";
                    break;
                case "04":
                    str = "Apr";
                    break;
                case "05":
                    str = "May";
                    break;
                case "06":
                    str = "Jun";
                    break;
                case "07":
                    str = "Jul";
                    break;
                case "08":
                    str = "Aug";
                    break;
                case "09":
                    str = "Sep";
                    break;
                case "10":
                    str = "Oct";
                    break;
                case "11":
                    str = "Nov";
                    break;
                case "12":
                    str = "Dec";
                    break;
            }
            return str;
        },
    },
};
</script>
<style scoped lang="css">
.hisTable {
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
}
.headerClass {
    font-size: 16px;
    color: white;
    background-color: #0d57bc;
}
.trOne {
    font-weight: bold;
}
.syccxhzHeader {
    width: 100%;
    height: 90px;

    font-size: 22px;
    text-align: center;
}
.sycBottom {
    width: 100%;
    height: 70px;
    line-height: 70px;

    float: right;
    font-weight: bold;
}
.sycDan {
    width: 10%;
    height: 20px;

    float: right;
    font-size: 13px;
}
</style>